// src/api/itemApi.js
import api from '../shared/AxiosConfig';

export const itemApi = {
    getItems: (params) => api.get('/item',{ params }),
    getRandomItems: (params) => api.get('/item/random-items',{ params }),
    getRandomItems2: (params) => api.get('/item/random-items2',{ params }),

    getItemBySlug: (slug) => api.get(`/item/${slug}`),
    searchItems: (params) => api.get('/item/search', { params }),
    filterItems: (params) => api.get('/item/filter', { params }),
    getItemsByCategory: (categorySlug) => api.get(`/item/category/${categorySlug}`),
    getItemsByColor: (colorSlug) => api.get(`/item/color/${colorSlug}`),

    addItem: (params) => api.post('/item', params),
    updateItem: (slug, data) => api.put(`/item/${slug}`, data),
    deleteItem: (slug) => api.delete(`/item/${slug}`)
};
